// 兼容 IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'babel-polyfill'

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'lib-flexible/flexible.js';
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '@ant-design/icons-vue';
import './style/index.css'
import Promise from 'es6-promise'
// ES6
import vshare from 'vshare'

// import '../node_modules/social-share.js/dist/css/share.min.css';
// import '../node_modules/social-share.js/dist/js/social-share.min.js';

Promise.polyfill();

Vue.use(Antd);
Vue.use(VueRouter)
Vue.use(vshare)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
